<template>
  <div class="popup-menu">
    <div class="menu-handler" @click="onMenuHandlerClick">
      <van-icon name="wap-nav" />
    </div>
    <MobilePersonalMenu
      v-model="showMenu"
      hasLogin
      :company="companyInfo"
      :hideReferralProgram="hideReferralProgram"
      :isEmployeeAccount="isEmployeeAccount"
      :hideCompanyMenu="hideCompanyMenu"
    />
  </div>
</template>

<script>
import MobilePersonalMenu from '@/components/menu/mobilePersonalMenu.vue'

export default {
  components: {
    MobilePersonalMenu
  },
  props: {
    companyInfo: {
      required: false,
      default: null
    },
    hideCompanyMenu: {
      type: Boolean,
      default: false
    },
    personalInfo: {
      required: true
    }
  },
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    isEmployeeAccount () {
      return Boolean(this.personalInfo.employee?.id)
    },
    hideReferralProgram () {
      const employee = this.personalInfo.employee
      return employee?.company.hide_referral_program
    }
  },
  created () {

  },
  methods: {
    onMenuHandlerClick () {
      this.showMenu = true
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-menu {
  .menu-handler {
    cursor: pointer;
    font-size: 28px;
    color: #7a7a7a;
  }

  .menu-list {
    background: #282b2e;

    .menu-item {
      border-bottom: 1px solid #030303;

      &:last-child {
        border-bottom: 0;
      }

      .menu-item-label {
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        font-size: 15px;
      }
    }
  }
}
</style>
